import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";


@Directive({
  selector: '[alphaNumeric]',
  providers: [{provide: NG_VALIDATORS, useExisting: AlphaNumericValidatorDirective, multi: true}],
  standalone: false
})

export class AlphaNumericValidatorDirective implements Validator{
  validate(control: AbstractControl): ValidationErrors | null {
    let nonAphaNumericRegex :RegExp = new RegExp("[^a-zA-Z0-9_ -]+","i");
    return nonAphaNumericRegex.test(control.value) && control.dirty? {nonAlphaNumeric: {value: true}}: null;
  }
}
